export const OutDocWarningCode = {
	noMapperForCompany: "no_mapper_for_company",
	requiredMapperFieldEmpty: "required_mapper_field_empty",
	noSourceDoc: "no_source_doc",
	sourceDocInvalid: "source_doc_invalid",
};

export const SourceDocErrorKind = {
	invalidFile: "invalid_file",
	emptyFile: "empty_file",
	requiredCellEmpty: "required_cell_empty",
};
